module.exports = __webpack_public_path__ + "img/querzugkraft_zzz.3cdf0ef6.jpg";